import { lazy } from 'react';

const Clients = lazy(() =>
  import('components/Clientes/Clients/Clients').then(module => ({
    default: module.Clients,
  }))
);

const routesClientes = [
  {
    path: "/catalogo-clientes",
    name: "Clientes",
    icon: "nc-icon nc-circle-10",
    component: <Clients />,
    permissions: ['168_CLIENTES_CATALOGO'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  }
]

export {
  routesClientes
}